<template>
  <div :class="themeStyleVs === 2 ? 'cl_page black_box' : 'cl_page'">
    <p class="num_main">共{{ total }}个</p>
    <!--  @scroll="scrollCl($event)" -->
    <div class="content_main cl_content_main">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
        @load="scrollCl"
      >
        <div
          class="cl_main"
          v-for="(item, index) in listData"
          :key="index"
          @click.stop="goDetails(item)"
        >
          <img
            class="top_img"
            v-if="item.sort_top && item.sort_top === 1"
            src="../../assets/image/zdtype.png"
            alt=""
          />
          <div class="top">
            <span class="tit">{{ item.s_name }}</span>
            <img
              :src="themeStyleVs === 2 ? dian_block : dian"
              alt=""
              @click.stop="yzProp(item, index)"
            />
          </div>
          <div class="intro_box">{{ item.s_desc }}</div>
          <div class="detail_cante">
            <div class="li_box">
              <div class="lf_box">
                <p :class="item.RiZhangFu | formateRedGreen">
                  {{ toFixedNum(item.RiZhangFu * 100, 2, '%') }}
                </p>
                <p>日涨幅</p>
              </div>
              <div class="rg_box">
                <p>{{ item.XinHaoShuLiang }}只</p>
                <p>今日信号</p>
              </div>
            </div>
            <div class="li_box">
              <div class="lf_box">
                <p :class="item.BestAvgRate | formateRedGreen">
                  {{ toFixedNum(item.BestAvgRate * 100, 2, '%')
                  }}<span>持股{{ item.BestAvgCycle }}天</span>
                </p>
                <p>最优平均涨幅</p>
              </div>
              <div class="rg_box">
                <p :class="item.MaxRiseRate | formateRedGreen">
                  {{ toFixedNum(item.MaxRiseRate * 100, 2, '%')
                  }}<span>持股{{ item.MaxRiseCycle }}天</span>
                </p>
                <p>最大上涨概率</p>
              </div>
            </div>
          </div>
        </div>
      </van-list>
      <van-empty
        v-if="queryShow && listData.length <= 0"
        class="custom-image"
        :image="not_data"
        description="暂未获取到数据"
      />
    </div>
    <van-popup v-model="popupShow" round position="bottom">
      <div class="popup_box">
        <ul class="controls_ul">
          <li v-if="popupData" @click="topMyFavorFn">
            {{ popupData.sort_top && popupData.sort_top === 1 ? '取消置顶' : '置顶' }}
          </li>
          <li @click="renameShow">重命名</li>
          <li @click="deleteFn">删除</li>
        </ul>
        <div class="close_box" @click="popupShow = false">取消</div>
      </div>
    </van-popup>
    <van-dialog
      v-model="show"
      title="重命名"
      :show-cancel-button="false"
      :show-confirm-button="false"
    >
      <div class="rename_main">
        <p>请输入您需要修改的名称：</p>
        <input v-model="name" type="text" placeholder="请输入策略名称" />
        <div class="fod_box">
          <div class="cancel_box" @click="cancelFn">取消</div>
          <div :class="name === '' ? 'confirm_box search_not' : 'confirm_box'" @click="confirmFn">
            确定
          </div>
        </div>
      </div>
    </van-dialog>
    <van-dialog
      v-model="dialogShow"
      :message="dialogMessage"
      cancelButtonColor="#999"
      confirmButtonColor="#286DF7"
      className="dialog_box"
      showConfirmButton
      showCancelButton
      @confirm="dialogFnConfirm"
    >
    </van-dialog>
  </div>
</template>

<script>
import mixins from '@/mixins/index.js';
// import { getMyFavor, getFactorTrend, topMyFavor } from '@/api/my.js';
import { getMyClInfo, topMyClInfo, renameClById, delMyClById } from '@/api/my.js';
import { getFactorHq } from '@/api/index.js';
import { newFangDouFun,compareVersions } from '@/utils/format.js';
export default {
  name: 'Gz',
  mixins: [mixins],
  data() {
    return {
      dian: require('@/assets/image/dian.png'),
      dian_block: require('@/assets/image/blockImg/dian_img.png'),
      ZhangYuShu: window.config.ZhangYuShu,
      hotTacticInterval: null, // 行情中定时器
      total: 0,
      page: 1,
      pageSize: 10,
      listData: [],
      popupShow: false,
      popupData: null,
      popupDataIndex: 0,
      show: false,
      name: '',
      queryShow: false,
      not_data: require('../../assets/image/notData.png'),
      themeStyleVs: 1,
      dialogShow: false,
      dialogMessage: '',
      loading: false,
      finished: false,
      finishedText: '没有更多了'
      // isNoMoreValue: false
    };
  },
  filters: {
    bgColor: function (num) {
      if (num > 0) {
        return 'one_year_box red_bg';
      } else if (num < 0) {
        return 'one_year_box green_bg';
      }
    }
  },
  created() {
    this.themeStyleVs = Number(this.getUrlQuery('themeStyleVs'));
  },
  mounted() {
    this.loading = true;
    this.getData();
    this.$toast.loading({
      message: '加载中...',
      overlay: true,
      duration: 0
    });
  },
  methods: {
    compareVersions,
    getData: function () {
      let that = this;
      let obj = {
        start: that.page,
        count: that.pageSize,
        type_info: compareVersions(that.$route.query.version , 9.69) ? 0 : 1 //0全部  1A股 2ETF
      };
      getMyClInfo(obj)
        .then((res) => {
          that.queryShow = true;
          that.$toast.clear();
          if (res.err === 200) {
            that.total = res.data.countData ? res.data.countData : 0;
            that.listData = [...that.listData, ...res.data.listData];
            that.getClHq();
            // that.hotTacticInterval = window.setInterval(() => {
            //   that.getClHq();
            // }, 60000);
            that.$nextTick(function () {
              if (res.data.listData.length < 10) {
                //是否已加载完成，加载完成后不再触发load事件
                that.finished = true;
              } else {
                that.loading = false;
                that.page += 1;
                that.finished = false;
              }
            });
          } else {
            that.finished = true;
            that.loading = true;
            that.finishedText = '';
            that.total = 0;
          }
        })
        .catch(() => {
          that.loading = true;
          that.finished = true;
          that.finishedText = '';
          that.queryShow = true;
          that.$toast.clear();
        });
    },
    // 获取策略行情
    getClHq: function () {
      let that = this;
      let idKeys = that.listData.map((item) => {
        return item.f_id_arr.replaceAll(',', '_');
      });
      idKeys = idKeys.toString();
      let obj = {
        type: 'cl',
        groupID: idKeys
      };
      getFactorHq(obj).then((res) => {
        if (res.err === 200) {
          res.data.forEach((item) => {
            that.listData.forEach((allItem, index) => {
              if (item.ID.replaceAll('_', ',') === allItem.f_id_arr) {
                that.$set(that.listData[index], 'RiZhangFu', item.RiZhangFu);
                that.$set(that.listData[index], 'XinHaoShuLiang', item.XinHaoShuLiang);
              }
            });
          });
        }
      });
    },
    // 策略滚动处理
    scrollCl: function (e) {
      let that = this;
      that.loading = true;
      // window.clearInterval(that.hotTacticInterval);
      // that.hotTacticInterval = null;
      that.$nextTick(function () {
        that.getData();
      });
    },
    // 因子点击显示弹框
    yzProp: function (item, index) {
      let that = this;
      that.popupShow = true;
      that.popupData = item;
      that.popupDataIndex = index;
    },
    // 置顶按钮
    topMyFavorFn: function () {
      let that = this;
      let obj = {
        s_id: that.popupData.s_id
      };
      topMyClInfo(obj).then((res) => {
        if (res.err === 200) {
          window.clearInterval(that.hotTacticInterval);
          that.hotTacticInterval = null;
          that.page = 1;
          that.listData = [];
          that.$nextTick(function () {
            that.queryShow = false;
            that.loading = true;
            that.getData();
            that.$toast(res.msg);
            that.popupShow = false;
          });
        }
      });
    },
    // 重命名弹框
    renameShow: function () {
      this.show = true;
      this.popupShow = false;
      this.name = this.popupData.s_name;
    },
    // 隐藏重命名弹框
    cancelFn: function () {
      this.show = false;
      this.name = '';
    },
    //点击确定按钮修改重命名弹框
    confirmFn: function () {
      if (this.name === '') {
        this.$toast('请输入名称');
        return;
      }
      renameClById({ s_id: this.popupData.s_id, s_name: this.name }).then((res) => {
        if (res.err === 200) {
          this.$toast(res.msg);
          this.$set(this.listData[this.popupDataIndex], 's_name', this.name);
        } else {
          this.$toast(res.msg);
        }
        this.show = false;
        this.name = '';
      });
    },
    deleteFn: function () {
      let that = this;
      that.dialogMessage = '是否确认取消关注' + "'" + that.popupData.s_name + "'" + '？';
      that.dialogShow = true;
    },
    dialogFnConfirm: function () {
      this.delFavor();
    },
    // 删除
    delFavor: function () {
      let that = this;
      let data = that.popupData;
      let obj = {
        s_id: data.s_id
      };
      delMyClById(obj).then((res) => {
        if (res.err === 200) {
          window.clearInterval(that.hotTacticInterval);
          that.hotTacticInterval = null;
          that.page = 1;
          that.listData = [];
          that.queryShow = false;
          that.loading = true;
          that.getData();
          that.$toast(res.msg);
          that.popupShow = false;
        }
      });
    },
    // 跳转详情
    goDetails: function (item) {
      let that = this;
      that.$nextTick(function () {
        this.gotoUrlInfo('/clDetail', 'clDetail', {
          s_id: item.s_id,
          type: 'mine',
          sourceType: true,
          themeStyleVs: that.themeStyleVs
        });
      });
    }
  },
  beforeDestroy() {
    let that = this;
    window.clearInterval(that.hotTacticInterval);
    that.hotTacticInterval = null;
  }
};
</script>
<style lang="less" scoped>
.cl_page {
  width: 100%;
  height: 100%;
  .num_main {
    padding: 8px 0;
    font-size: 12px;
    color: #555;
    padding-left: 12px;
  }
  .content_main {
    width: 100%;
    height: calc(100% - 32px);
    box-sizing: border-box;
    overflow: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    .list_main {
      width: 100%;
      height: 100%;
    }
    &.cl_content_main {
      padding: 0 12px;
      .cl_main {
        width: 100%;
        background-color: #fff;
        box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        padding: 15px 12px;
        box-sizing: border-box;
        margin-bottom: 8px;
        position: relative;
        box-shadow: 0px 4px 20px 0px rgba(0, 13, 134, 0.1);
        .top_img {
          position: absolute;
          top: 5px;
          left: 5px;
          width: 10px;
          height: 10px;
        }
        .top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 8px;
          .tit {
            font-size: 16px;
            color: #373a4d;
            font-weight: 500;
          }
          img {
            display: inline-block;
            width: 24px;
            height: 24px;
          }
        }
      }
      .intro_box {
        font-size: 12px;
        line-height: 16px;
        color: #666666;
        margin-bottom: 8px;
      }
      .detail_cante {
        width: 100%;
        .li_box {
          margin-bottom: 4px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          &:last-child {
            margin-bottom: 0;
          }
          div {
            width: 158px;
            padding: 9px 0;
            box-sizing: border-box;
            background: #f9f9f9;
            border-radius: 4px;
            text-align: center;
            p {
              span {
                font-size: 10px;
                color: #666666;
                margin-left: 4px;
              }
              &:first-child {
                font-weight: 500;
                font-size: 16px;
                color: #373a4d;
              }
              &:last-child {
                font-size: 12px;
                color: #999999;
                line-height: 14px;
              }
            }
          }
        }
      }
    }
  }
  .popup_box {
    width: 100%;
    padding-top: 20px;
    box-sizing: border-box;
    .controls_ul {
      width: 100%;
      li {
        display: inline-block;
        width: 100%;
        height: 50px;
        line-height: 50px;
        padding-left: 16px;
        font-size: 16px;
        color: #555;
        border-bottom: 1px solid #e5e5e5;
        &:last-child {
          border: none;
        }
      }
    }
    .close_box {
      width: 100%;
      height: 50px;
      border-top: 1px solid #e5e5e5;
      text-align: center;
      line-height: 50px;
      color: #555;
      font-size: 16px;
    }
  }
  .rename_main {
    width: 100%;
    padding: 16px;
    p {
      font-size: 14px;
      color: #555;
      margin-bottom: 4px;
    }
    input {
      width: 100%;
      height: 38px;
      border-radius: 4px;
      border: 0.5px solid #e5e5e5;
      padding-left: 9px;
      font-size: 14px;
      margin-bottom: 32px;
    }
    .fod_box {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      div {
        padding: 8px 45px;
        border-radius: 6px;
      }
      .cancel_box {
        background: #f7f8fa;
        color: #222;
      }
      .confirm_box {
        background: #286df7;
        color: #fff;
      }
      .search_not {
        opacity: 0.5;
      }
    }
  }
}
.black_box {
  .num_main {
    color: #aab9d1;
  }
  .content_main.cl_content_main {
    .cl_main {
      background-color: #181a23;
      box-shadow: 0px 4px 20px 0px rgba(0, 13, 134, 0.1);
      .top {
        .tit {
          color: #e4e9fe;
        }
      }
    }
    .intro_box {
      color: #aab9d1;
    }
    .detail_cante {
      .li_box {
        div {
          background-color: #1d202d;
          p {
            &:first-child {
              color: #e4e9fe;
              span {
                color: #aab9d1;
              }
            }
            &:last-child {
              color: #6b7687;
            }
          }
        }
      }
    }
  }
  .rename_main {
    p {
      color: #aab9d1;
    }
    input {
      border: 0.5px solid rgba(229, 229, 229, 0.2);
      background: #181a23;
      color: #e4e9fe;
    }
    .fod_box {
      .cancel_box {
        background: #1d202d;
        color: #e4e9fe;
      }
      .confirm_box {
        background-color: #3b85fe;
        color: #181a23;
      }
    }
  }
}
</style>
